import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import { requireSecureContext } from './secure-context';

// A build with no API behind it serves itself, so the dashboard can be handed
// over as one file and still work. Tree-shaken out of a normal build.
if (import.meta.env.VITE_STANDALONE) {
  const { installStandaloneApi } = await import('./standalone');
  installStandaloneApi();
}

const host = document.getElementById('root');
if (!host) throw new Error('missing #root');

// Before anything else. The back office refuses to run over plain HTTP, and the
// reasoning — including why this is a stop rather than a warning, and why the
// guest widget does the opposite — is in secure-context.ts.
if (requireSecureContext(host)) {
  createRoot(host).render(<StrictMode><App /></StrictMode>);
}
